// src/services/settingService.js
import apiClient from './apiClient';

export const settingService = {
  /**
   * 获取所有系统设置
   * @returns {Promise<Array>}
   */
  getSettings: async () => {
    try {
      const data = await apiClient.get('/api/settings');
      return data;
    } catch (error) {
      console.error('Failed to fetch settings:', error);
      throw error;
    }
  },

  /**
   * 批量更新系统设置
   * @param {Array} settings - 设置对象列表 [{key, value}, ...]
   * @returns {Promise<Object>}
   */
  updateSettings: async (settings) => {
    try {
      const data = await apiClient.put('/api/settings', settings);
      return data;
    } catch (error) {
      console.error('Failed to update settings:', error);
      throw error;
    }
  }
};

export default settingService;
